<div class="container-fluid vh-100">
  <div class="vh-100 vw-100 d-flex justify-content-center text-center align-items-center">{{ message }}</div>
</div>
